export default "__VITE_ASSET__CWNOkGoP__"